module.exports = __webpack_public_path__ + "static/img/enourAdvantage.e678cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enourAdvantage.png
// module id = EIwO
// module chunks = 1